var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-section" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-10" }, [
          _c(
            "div",
            {
              staticClass: "collapse-section",
              class: {
                "open-collapse": _vm.collapsible,
                "close-collapse": !_vm.collapsible
              },
              style: _vm.collapsseStyle()
            },
            [
              _c("h1", [
                _vm._v(
                  "Get offers on electricity from several suppliers in Stockholm"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Tecknael.se is a free tender service without bindings. You fill out the form and the companies that supply electricity in the Stockholm area are competing to give you their lowest price."
                )
              ]),
              _vm._v(" "),
              _c("h3", [
                _vm._v("The electricity market in the Stockholm region:")
              ]),
              _vm._v(" "),
              _c("page-navigation", { attrs: { miniNav: "true" } }),
              _vm._v(" "),
              _c("h3", [_vm._v("Elavtal Stockholm")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Söker du elavtal i Stockholmsområdet? I så fall gör du rätt i att använda dig av TecknaEl. Med TecknaEl jämför du enkelt elavtal från olika elbolag i Stockholm. På så vis kan du få billig el i Stockholm och spara hundralappar på elräkningen varje månad. Hos oss byter du elavtal snabbt och enkelt. Dessutom är TecknaEl helt kostnadsfri - så att du ska kunna jämföra elavtal i Stockholm och hitta rätt val för dig, utan någon press. Bli ett av de hushåll som har sänkt sina månadskostnader med hjälp av TecknaEl!"
                )
              ]),
              _vm._v(" "),
              _c("h3", [
                _vm._v("Hitta det bästa och billigaste elavtalet i Stockholm")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Att hitta det bästa och billigaste elavtalet i Stockholm har länge verkat som en omöjlig uppgift. Med TecknaEl blir dock detta en verklighet. Det finns många konkurrerande elbolag i Stockholm och det kan vara snårigt att hitta bäst deal bland alla dessa. På TecknaEl kan du enkelt och lätt jämföra elbolag i Stockholm för att hitta billigast elavtal. Dessutom kan du välja precis den typ av el du vill ha. Vill du ha klimatsmart, fossilfri el till din lägenhet eller villa i Stockholm? Genom TecknaEl kan du jämföra vad för typ av el de olika företagen erbjuder, oavsett om du bor på Södermalm, Kungsholmen, i Bromma eller någon annan del av Stockholm - utan att det kostar dig ett öre."
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("Jämför elavtal i Stockholm")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "De allra flesta misstänker nog att de hade kunnat sänka sina månatliga elkostnader om de verkligen. Det kan dock kännas krångligt att sätta sig in i elmarknaden och manuellt jämföra de olika elbolagen i Stockholm. Med TecknaEl så kan du själv undersöka elmarknaden i Stockholm på några få knapptryck. Du väljer själv vad du vill ha för typ av elavtal - så ger TecknaEl dig verktygen för att jämföra dem. Oavsett om du vill ha rörligt elavtal, fast elavtal, eller el till mixpris i Stockholm så finns vi här för dig!"
                )
              ]),
              _vm._v(" "),
              _c("h3", [_vm._v("Elmarknaden i Stockholmsområdet ")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "I Stockholm finns det över 100 olika elhandelsbolag. Dessutom finns det flera olika nätägare, vilket är dem som äger och underhåller ditt lokala elnät. Du kan inte ändra din nätägare, men däremot kan du byta elhandelsbolag och därigenom ditt elavtal. Det är dock svårt att veta vilka elbolag som är billigast, mest klimatsmarta, eller helt enkelt bäst i Stockholm. Stockholm befinner sig i elområde SE3, vilket generellt är ett av de dyrare elområdena i Sverige. Det blir därför extra viktigt att ha en pålitlig och enkel tjänst för att kunna jämföra elavtal i Stockholm. Detta är precis vad TecknaEl erbjuder."
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "read-more",
              class: { "open-read": _vm.collapsible }
            },
            [
              _c(
                "button",
                {
                  staticClass: "open-full-btn",
                  on: {
                    click: function($event) {
                      return _vm.openCSection()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.textReadMore) + "\n                        "
                  ),
                  _c("img", {
                    attrs: { src: "/img/icon/arrow_round.svg", alt: "" }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(0)
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "center" } }, [
      _c("button", [_vm._v("Get cheaper electricity now")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }